import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

//
import Moment from "react-moment";
import { Card, Button } from "react-bootstrap";

//
import PageHeader from "../general/PageHeader";
import Pagination from "../general/Pagination";
import NothingToShow from "../general/NothingToShow";


function DesktopNotifications({ notifications, showModal }) {
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(10);

  const changePage = (page) => {
    setPage(page);
    let start = (page - 1) * 10;

    setStartIndex(start);
    setEndIndex(start + 10);
  };

  useEffect(() => {
    setLastPage(Math.ceil(notifications.length / 10));
  }, [notifications]);

  return (
    <>
      <PageHeader
        title="Notification"
        subject="Crypto details overview and analytics"
      >
        {!!notifications.length && (
          <Button
            size="lg"
            variant="white"
            className="with-icon"
            onClick={showModal}
          >
            <i className="lar la-trash-alt pointer"></i>
            <span className="text-black">Delete All Messages</span>
          </Button>
        )}
      </PageHeader>

      <Card>
        <Card.Header>
          Earlier
          {/* <small className="text-info fw-bolder">Mark all as read</small> */}
        </Card.Header>

        <Card.Body className="py-0">
          {notifications.length ? (
            <>
              {notifications.slice(startIndex, endIndex).map((item, index) => (
                <div className="item" key={index}>
                  <div className="title-box">
                    <span
                      // className={`icon-box ${
                      //   item.title === "Reminder" ? "warning" : "success"
                      // }`}
                      className="icon-box warning"
                    >
                      <i
                        className="las la-info-circle"
                        // className={`las ${
                        //   item.title === "Reminder" ? "la-info-circle" : "la-check"
                        // }`}
                      ></i>
                    </span>
                    <div>
                      {item.symbol ? (
                        <Link
                          to={`/app/coin-detail/${item.symbol}`}
                          className="fw-bolder"
                        >
                          {item.title}
                        </Link>
                      ) : (
                        <p className="fw-bolder text-dark">{item.title}</p>
                      )}
                      <small className="text-muted">{item.message}</small>
                    </div>
                  </div>

                  <div className="time-box">
                    <small>
                      <Moment utc fromNow>
                        {item.created_at}
                      </Moment>
                    </small>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <NothingToShow text="Nothing to show" />
          )}
        </Card.Body>

        {lastPage > 1 && (
          <Card.Footer>
            <small>
              Showing
              <span className="fw-bolder mx-1">
                {notifications.slice(startIndex, endIndex).length}
              </span>
              of
              <span className="fw-bolder mx-1">{notifications.length}</span>
              messages
            </small>
            <Pagination
              currentPage={page - 1}
              lastPage={lastPage}
              changePage={(page) => changePage(page.selected + 1)}
            />
          </Card.Footer>
        )}
      </Card>
    </>
  );
}

DesktopNotifications.propTypes = {
  notifications: PropTypes.array.isRequired,
  showModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  notifications: state.userReducer.notifications,
});

export default connect(mapStateToProps)(DesktopNotifications);
